/*eslint-disable*/
import axios from "axios";
import router from "../../router";

// Traduce un errore axios (rete irraggiungibile, timeout, risposta HTTP di errore, ecc.)
// in un messaggio comprensibile da mostrare all'utente.
export function getFriendlyErrorMessage(error, contextMessage) {
    var prefix = contextMessage ? contextMessage + ": " : "";

    if (!error) {
        return prefix + "Si è verificato un errore imprevisto.";
    }

    if (error.response) {
        // Il server ha risposto con un codice di errore
        var status = error.response.status;
        var serverMessage =
            (error.response.data && (error.response.data.message || error.response.data.error)) || null;

        if (status === 401 || status === 403) {
            return prefix + "Accesso negato: utente o password non validi, oppure sessione scaduta.";
        }
        if (status === 404) {
            return prefix + "Servizio non trovato sul server (errore 404). Contattare l'assistenza.";
        }
        if (status >= 500) {
            return prefix + "Il server ha riscontrato un errore interno (" + status + "). Riprovare più tardi.";
        }
        return prefix + "Il server ha restituito un errore (" + status + ")" +
            (serverMessage ? ": " + serverMessage : ".");
    }

    if (error.request) {
        // La richiesta è stata inviata ma non è arrivata alcuna risposta
        return prefix + "Impossibile contattare il server. Verificare la connessione di rete o riprovare più tardi.";
    }

    // Errore avvenuto prima dell'invio della richiesta
    return prefix + "Errore durante la chiamata al servizio: " + (error.message || error);
}

export class Utils {

    constructor() {

    }
/*
    checkLogin(ad_user_id) {
        ///var ad_user_id = this.session.get("ad_user_id");
        console.log(ad_user_id)
        if (!ad_user_id) {
          router.push({
            name: "Login"
          });
        }
    }
*/
    axiosPost(urlPostRequest, params, resolve, reject) {
        axiosPost(urlPostRequest, params, resolve, reject, false)
    }

    axiosPost(urlPostRequest, params, resolve, reject, debugEnabled) {

        //axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";

        axios.post(urlPostRequest, JSON.stringify(params), {
        headers: {
            "Content-type": "application/json;charset=utf-8"
        }
        })
        .then(response => {
            if (params.debug) {
                console.log("debug response");
                console.log(response)
            }

            resolve(response.data);
        }).catch(e => {
            console.log("Eccezione");
            console.log(e);
            e.friendlyMessage = getFriendlyErrorMessage(e);
            reject(e);
            //this.errors.push(e)
        });
    }

}
